<style>
.filter-input {
  max-width: 400px;
}

.filter-number {
  max-width: 120px;
}

/* the size note beside the results title: two short lines */
.size-warning {
  font-size: 12px;
  line-height: 1.3;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>
<template>
  <v-card flat>
    <!--    <v-toolbar flat>-->
    <!--      <v-text-field-->
    <!--        v-model="search"-->
    <!--        append-icon="mdi-magnify"-->
    <!--        label="Search (meal name or meal id number)"-->
    <!--        single-line-->
    <!--        hide-details-->
    <!--        clearable-->
    <!--      />-->
    <!--      <v-spacer/>-->
    <!--    </v-toolbar>-->
    <v-card-text>
      <v-row>
        <v-col>
          <v-tabs v-model="currentTab" class="mb-4">
            <v-tab>Presets Diets</v-tab>
            <v-tab>Nutrient Filters</v-tab>
          </v-tabs>
          <v-row align="center">
            <v-col>
              <v-autocomplete
                label="Load a Filter"
                v-model="filterName"
                :items="filteredAvailableFilters"
                item-value="id"
                item-text="id"
                @change="applyFilter(filterName)"
                clearable
              />
            </v-col>
            <v-col cols="auto">
              <v-btn @click="newFilter" outlined>
                New/Clear
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card v-if="!editingDefinition" outlined class="mb-2" data-cy="filter-definition-line">
                <v-card-text class="d-flex align-center py-2">
                  <span class="text-truncate">
                    <b>{{ filterName }}</b>
                    <span v-if="filterTitle"> · {{ filterTitle }}</span>
                    <span v-if="filterDescription" class="grey--text"> · {{ filterDescription }}</span>
                    <v-chip v-if="filterIsHardRule" x-small outlined class="ml-2">hard rule</v-chip>
                    <v-chip v-if="filterName && hasUnpublishedChanges" x-small color="warning" outlined class="ml-2" @click="showChangesDialog = true">
                      unpublished changes
                    </v-chip>
                  </span>
                  <v-spacer/>
                  <v-btn icon small @click="editingDefinition = true" title="Edit the filter's id, title and description" data-cy="filter-definition-edit">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
              <v-card v-else>
                <v-card-text>
                  <v-text-field
                    label="Filter ID"
                    v-model="filterName"
                    :rules="[v => /^[a-z0-9\-]+$/i.test(v) || 'must not contain spaces or special characters']"
                    :disabled="isLoadedFilter"
                    @blur="checkForExistingFilter"
                  />
                  <v-text-field
                    label="Filter Title  (displayed to customer)"
                    v-model="filterTitle"
                  />
                  <v-text-field
                    label="Filter Description (displayed to customer)"
                    v-model="filterDescription"
                  />
                  <v-row>
                    <v-checkbox v-model="filterIsHardRule"
                                class="pl-4"
                                label="Hard Rule"
                                data-cy="filter-hard-rule"/>
                    <span class="text-caption grey--text ml-2 mt-4">
                      A meal that misses any target or restriction is left out of the customer's
                      personal menu instead of being ranked lower. Takes effect on publish.
                    </span>
                  </v-row>
                  <v-row v-if="filterName && hasUnpublishedChanges" class="pl-4">
                    <v-col>
                      <v-alert type="warning" dense text>
                        This filter has unpublished changes
                        <v-btn small @click="showChangesDialog = true" class="ml-2">
                          Show Changes
                        </v-btn>
                      </v-alert>
                    </v-col>
                  </v-row>
                  <div class="text-right">
                    <v-btn small text :disabled="!filterName" @click="editingDefinition = false" data-cy="filter-definition-done">
                      <v-icon small left>mdi-check</v-icon>
                      Done
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>

              <v-toolbar flat>
                <v-btn class="ml-2" @click="publishFilter"
                       :disabled="!filterName || publishing || (filterIsPublished && !hasUnpublishedChanges)"
                       :loading="publishing"
                       :color="filterIsPublished && !hasUnpublishedChanges ? 'success' : 'primary'">
                  <v-icon v-if="filterIsPublished && !hasUnpublishedChanges" small left>mdi-check</v-icon>
                  {{ filterIsPublished && !hasUnpublishedChanges ? 'Published' : 'Publish' }}
                </v-btn>
                <v-btn class="ml-2" @click="checkUsageAndUnpublish"
                       :disabled="!filterName || !filterIsPublished || unpublishing" :loading="unpublishing"
                       color="error" outlined>
                  Unpublish
                </v-btn>
                <v-spacer/>
                <v-btn class="ml-2" @click="saveFilter" :loading="saving">
                  Save Filter
                </v-btn>
              </v-toolbar>
              <v-toolbar flat dense>
                <v-btn class="ml-2" @click="checkFilterUsage"
                       :disabled="!filterName || !filterIsPreset" :loading="checkingUsage"
                       outlined small>
                  <v-icon small left>mdi-account-group</v-icon>
                  Check Usage
                </v-btn>
                <v-btn class="ml-2" @click="toggleFilterType"
                       :disabled="!filterName"
                       outlined small>
                  <v-icon small left>mdi-swap-horizontal</v-icon>
                  Convert to {{ filterIsPreset ? 'Filter' : 'Preset' }}
                </v-btn>
              </v-toolbar>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="">
          <v-row dense>
            <v-col>
              <v-card flat>
                <v-card-subtitle class="pb-0 d-flex align-center">
                  Restrictions
                  <v-spacer/>
                  <v-btn v-if="!editingRestrictions" icon small @click="editingRestrictions = true" title="Change the restrictions" data-cy="filter-restrictions-edit">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn v-else-if="restriction.length" small text @click="editingRestrictions = false" data-cy="filter-restrictions-done">
                    <v-icon small left>mdi-check</v-icon>
                    Done
                  </v-btn>
                </v-card-subtitle>
                <v-card-text v-if="!editingRestrictions" class="py-1" data-cy="filter-restrictions-line">
                  {{ restrictionLine }}
                </v-card-text>
                <v-card-text v-else-if="restrictions">
                  <v-autocomplete
                    v-model="restriction"
                    :items="restrictionsArray"
                    item-text="text"
                    item-value="id"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    dense
                    hide-details
                    placeholder="Select restrictions"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        small
                        close
                        @click:close="restriction.splice(index, 1)"
                        color="grey lighten-3"
                        class="ma-1"
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-card flat>
                <v-card-title class="d-flex align-center py-2">
                  <span class="text-subtitle-1">Nutrient Targets</span>
                  <v-spacer/>
                  <v-btn small outlined @click="addTarget">
                    <v-icon small left>mdi-plus</v-icon>
                    Add Nutrient Target
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-row dense class="mb-2">
                    <v-col>
                      <v-checkbox
                        label="Daily Target (based on 3 meals)"
                        v-model="isDailyTarget"
                        dense
                        hide-details
                        class="mt-0"
                      />
                    </v-col>
                    <v-col>
                      <v-checkbox
                        label="Only Tracked Nutrients"
                        v-model="onlyTracked"
                        dense
                        hide-details
                        class="mt-0"
                      />
                    </v-col>
                  </v-row>

                  <div v-for="(target,i) of targets" :key="i" class="mb-2">
                    <div v-if="i !== editingTargetIndex && target.nutrient_id" class="d-flex align-center" data-cy="filter-target-line">
                      <v-btn @click="removeTarget(i)" icon small color="error" title="Remove this target">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                      <span class="ml-1 text-truncate">{{ targetLine(target) }}</span>
                      <v-spacer/>
                      <v-btn icon small @click="editingTargetIndex = i" title="Edit this target" data-cy="filter-target-edit">
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                    <template v-else>
                      <v-row dense align="center" v-if="nutrients">
                        <v-col cols="auto">
                          <v-btn
                            @click="removeTarget(i)"
                            icon
                            small
                            color="error"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col>
                          <v-autocomplete
                            v-model="target.nutrient_id"
                            :items="nutrientsFiltered"
                            item-text="nutrientname"
                            item-value="nutrientnameid"
                            outlined
                            dense
                            hide-details
                            placeholder="Select nutrient"
                          />
                        </v-col>
                      </v-row>
                      <v-row dense v-if="target.nutrient_id" class="mt-2">
                        <v-col cols="auto" style="width: 50px;"></v-col>
                        <v-col cols="3">
                          <v-text-field
                            v-model="target.lower_limit"
                            :suffix="getUnit(target)"
                            label="Min"
                            type="number"
                            outlined
                            dense
                            hide-details
                          />
                        </v-col>
                        <v-col cols="3">
                          <v-text-field
                            v-model="target.upper_limit"
                            :suffix="getUnit(target)"
                            label="Max"
                            type="number"
                            outlined
                            dense
                            hide-details
                          />
                        </v-col>
                        <v-col cols="3">
                          <v-text-field
                            v-model="target.target"
                            :suffix="getUnit(target)"
                            label="Target"
                            type="number"
                            outlined
                            dense
                            hide-details
                          />
                        </v-col>
                        <v-col cols="auto">
                          <v-btn icon small @click="editingTargetIndex = null" title="Done" data-cy="filter-target-done">
                            <v-icon small>mdi-check</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </div>

                  <v-alert v-if="targets.some(t => !!t.target)" type="warning" dense text class="mt-3">
                    The value in target is not considered in personalised menus, use min/max instead. It won't hurt to
                    add a
                    target and personal menus may support target later.
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-card-text>
    <v-card>
      <v-card-actions flat class="align-self-start px-10 ">
        <v-btn-toggle v-model="checkMode" mandatory dense class="mb-2 mr-4" data-cy="filter-check-mode">
          <v-btn value="live" small title="Check in the browser as the filter changes, every meal size">Live</v-btn>
          <v-btn value="server" small title="The server's check (medium size only), the backup if live looks wrong">Server</v-btn>
        </v-btn-toggle>
        <v-btn v-if="checkMode === 'server'" class="mb-2" @click="check" :loading="checking" data-cy="filter-check">Check Meals</v-btn>
        <span v-else-if="filterDataPending" class="text-caption grey--text mb-2" data-cy="filter-data-loading">
          loading meal data, {{ filterDataLoaded }} of {{ meals.length }}
        </span>
        <v-spacer/>
        <v-btn class="ml-2 mb-2" icon @click="skipWeek(-1)" title="Previous Week">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <date-picker
          class="ml-2"
          style="width: 400px"
          :dates.sync="dates"
        />
        <v-btn class="ml-2 mb-2" icon @click="skipWeek(1)" title="Next Week">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer/>
        <DebouncedTextField
          class="ml-4"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search (meal name or meal id number)"
          style="max-width: 400px"
          clearable
        />
      </v-card-actions>
      <template v-if="isCheckStale">
        <v-card-text>
          <v-alert outlined type="warning">The results below need to be checked again</v-alert>
        </v-card-text>
      </template>
    </v-card>
    <template v-if="!isCheckStale">
      <v-card-title class="d-flex align-center flex-wrap">
      <span v-if="showCriteria==='all'">
        {{ filteredMeals.length }} meals found
      </span>
        <span v-if="showCriteria!=='all'">
        {{ filteredMeals.length }} of {{ meals.length }} {{
            showCriteria
          }} meals ({{ ((filteredMeals.length / meals.length) * 100).toFixed(1) }}%)
      </span>
        <v-alert type="info" dense text class="size-warning ml-6 my-0" data-cy="filter-size-warning">
          Valid/problem is judged on the <b>medium</b> size; a customer's personal menu checks <b>their</b> size.<br/>
          The Sizes column shows which sizes meet every target.
        </v-alert>
      </v-card-title>
      <v-card-actions>
        <v-radio-group label="Showing Criteria" row v-model="showCriteria">
          <v-radio value="all" label="All">All</v-radio>
          <v-radio value="problem" label="Problem"/>
          <v-radio value="valid" label="Valid"/>
        </v-radio-group>
      </v-card-actions>
      <v-card-text>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="filteredMeals"
          sort-by="date"
          :loading="loading || checking"
          no-data-text="select a date range"
          disable-pagination
          hide-default-footer
          dense
        >
          <template v-slot:item.sku="{ item }">
            <v-btn icon shaped :class="{ yellow : item.is_selected}" class="mr-2" disabled>
              <v-icon>mdi-star</v-icon>
            </v-btn>
            <MealSkuLink :sku="item.sku"/>

          </template>
          <template v-slot:item.sizes="{ item }">
            <span v-if="item.sizes" class="text-no-wrap" data-cy="filter-sizes">
              <v-chip
                v-for="size of mealSizes"
                v-bind:key="size"
                x-small
                label
                :outlined="!item.sizes[size]"
                :color="item.sizes[size] === null ? 'grey' : (item.sizes[size] ? 'success' : 'warning')"
                class="mr-1"
                :title="`${size}: ${item.sizes[size] === null ? 'not checked' : (item.sizes[size] ? 'meets every target' : 'misses a target')}`"
              >
                {{ size[0].toUpperCase() }}
              </v-chip>
            </span>
          </template>
          <template v-for="(t,i) of targets"
                    v-slot:[`item.targets.${t.nutrient_id}`]="{ item }">
            <div v-bind:key="i" v-if="item.targets[t.nutrient_id]">
              {{ item.targets[t.nutrient_id].amount.toFixed(2) }} {{ item.targets[t.nutrient_id].unit }}
              <v-chip-group v-if="item.targets[t.nutrient_id].problem">
                <v-chip outlined color="warning" v-for="(v,k) of item.targets[t.nutrient_id].problem" v-bind:key="k">
                  {{ k }}: {{ v.toFixed(2) }}
                </v-chip>
              </v-chip-group>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </template>

    <!-- Changes Dialog -->
    <v-dialog v-model="showChangesDialog" max-width="800">
      <v-card>
        <v-card-title>
          Unpublished Changes
          <v-spacer/>
          <v-btn icon @click="showChangesDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(change, index) in formattedChanges" :key="index">
              <v-list-item-content>
                <v-list-item-title>
                  <v-chip small
                          :color="change.type === 'CREATE' ? 'success' : change.type === 'REMOVE' ? 'error' : 'warning'"
                          class="mr-2">
                    {{ change.type }}
                  </v-chip>
                  {{ change.path }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="change.oldValue !== undefined">
                  <strong>Published:</strong> {{ change.oldValue }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="change.value !== undefined">
                  <strong>Draft:</strong> {{ change.value }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="showChangesDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Usage Dialog -->
    <v-dialog v-model="showUsageDialog" max-width="600">
      <v-card>
        <v-card-title>
          Filter Usage
          <v-spacer/>
          <v-btn icon @click="showUsageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="filterUsers.length === 0" type="info" text>
            No customers are currently using this preset.
          </v-alert>
          <v-list v-else>
            <v-list-item v-for="(user, index) in filterUsers" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ user.email }}
                  <v-chip v-if="user.isPendingEdit" x-small color="warning" class="ml-2">Pending Edit</v-chip>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small icon :to="{ name: 'Customer', params: { uid: user.uid } }" target="_blank">
                  <v-icon small>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-alert v-if="filterUsers.length > 0" type="warning" text class="mt-3">
            {{ filterUsers.length }} customer{{ filterUsers.length > 1 ? 's are' : ' is' }} using this preset.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="showUsageDialog = false">Close</v-btn>
          <v-btn v-if="filterIsPublished" color="error" text @click="showUsageDialog = false; unpublishFilter();">
            Unpublish Anyway
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>


<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import {dateFormatted, deepCopy} from '@/store/utils';
import api from '@/api';
import MealSkuLink from "@/components/MealSkuLink";
import urlState from "@/router/urlState";
import DatePicker from "@/components/DatePicker";
import DebouncedTextField from "@/components/DebouncedTextField.vue";
import diff from 'microdiff';
import debounce from 'lodash/debounce';
import {checkMealData, MEAL_SIZES, mealTargets, restrictedTagsOf} from '@/utils/meal-filter-check';

// meals/filter-data a batch at a time, a few batches in flight
const FILTER_DATA_BATCH = 20;
const FILTER_DATA_CONCURRENCY = 3;

export default {
  components: {DatePicker, MealSkuLink, DebouncedTextField},
  mixins: [urlState],
  data() {
    return {
      readOnly: true,
      loading: false,
      checking: false,
      loadingPromise: undefined,
      mealMap: {},
      meals: [],
      defaultHeaders: [
        {text: 'Meal Id', value: 'id', width: 100},
        {text: 'SKU', value: 'sku', width: 180},
        {text: 'name', value: 'name'},
        {text: 'diet', value: 'diet'},
        {text: 'date', value: 'date'},
        {text: 'Sizes passing', value: 'sizes', sortable: false, width: 140},
      ],
      // 'live': checked here as the filter changes, on meals/filter-data; 'server': the older per-meal server check
      checkMode: 'live',
      // the definition, restrictions and each target fold to a line once entered; these open them
      editingDefinition: true,
      editingRestrictions: true,
      editingTargetIndex: null,
      filterData: {},
      filterDataLoaded: 0,
      filterDataPending: false,
      search: null,
      showImages: true,
      needPlatingOrPackingImage: null,
      targets: [],
      lastTargetSearch: null,
      isDailyTarget: true,
      showCriteria: 'all',
      restriction: [],
      targetHeaders: [],
      restrictionHeaders: [],
      filterName: null,
      availableFilters: [],
      filterTitle: '',
      filterDescription: '',
      filterIsPreset: '',
      filterIsPublished: null,
      filterIsHardRule: null,
      onlyTracked: true,
      restrictions: [],
      dates: this.getNextWeekDates(),
      currentTab: 0,
      publishing: false,
      unpublishing: false,
      saving: false,
      publishedFilter: null,
      showChangesDialog: false,
      showUsageDialog: false,
      checkingUsage: false,
      filterUsers: [],
      isLoadedFilter: false
    }
  },
  async created() {
    Promise.all([
      this.fetchDiets(),
      this.fetchNutrients(),
      api.get(`substitutions/`)
        .then(({data}) => {
          console.log('data', data);
          this.restrictions = data
        })
    ])
      .then(() => {
        this.fetchData();
      });
    this.readOnly = !!this.$route.meta.readOnly;
    this.syncToUrl({
      param: 'isDailyTarget', urlParam: 'daily', initFromRoute: true,
      parseCallback: (v) => v === 'true'
    })
    this.syncToUrl({
      param: 'showCriteria', urlParam: 'show', initFromRoute: true,
    })
    this.syncToUrl({
      param: 'checkMode', urlParam: 'mode', initFromRoute: true,
    })
    // a slight pause while a limit is being typed, then every meal is checked again
    this.scheduleLiveCheck = debounce(() => this.applyLiveCheck(), 300);
    this.syncToUrl({
      param: 'filterName', urlParam: 'filter', initFromRoute: true,
      // parseCallback: (v) => Number(v)
    });
    this.syncToUrl({
      param: 'filterIsPreset', urlParam: 'filterIsPreset', initFromRoute: true,
      // parseCallback: (v) => Number(v)
    });
    this.syncToUrl({
      param: 'search', urlParam: 'search', initFromRoute: true,
      // parseCallback: (v) => Number(v)
    });
    this.syncToUrl({
      param: 'dates', urlParam: 'dates', initFromRoute: true,
      parseCallback: (v) => Array.isArray(v) ? v : [v]
    });
    this.syncToUrl({
      param: 'restriction', urlParam: 'restriction', initFromRoute: true,
      parseCallback: v => v.map ? v : [v]
    });

    this.syncToUrl({
      param: 'currentTab', urlParam: 'tab', initFromRoute: true,
      parseCallback: (v) => Number(v)
    });

    function parseTarget(s) {
      console.log('parse', s);
      let [nutrient_id, lower_limit, upper_limit, target] = s.split(',').map(v => v && Number(v));
      return {nutrient_id, lower_limit, upper_limit, target}

    }

    function transformTarget(t) {
      return [t.nutrient_id, t.lower_limit, t.upper_limit, t.target].join(',');
    }

    this.syncToUrl({
      param: 'targets', urlParam: 'targets', initFromRoute: true, paramWatchOptions: {deep: true},
      transformCallback: v => v.map ? v.map(transformTarget) : transformTarget(v),
      parseCallback: v => v.map ? v.map(parseTarget) : [parseTarget(v)]
    })

    await this.fetchFilters();
    if (this.filterName) {
      this.applyFilter(this.filterName)
    }

  },
  watch: {
    dates() {
      this.fetchData();
    },
    targets: {
      deep: true,
      handler() {
        this.scheduleLiveCheck();
      },
    },
    restriction() {
      this.scheduleLiveCheck();
    },
    isDailyTarget() {
      this.scheduleLiveCheck();
    },
    checkMode(mode) {
      if (mode === 'live') {
        this.applyLiveCheck();
      } else {
        // the server's results are stale until Check Meals is pressed
        this.lastTargetSearch = null;
      }
    },
    currentTab(newTab) {
      // Automatically set filterIsPreset based on the tab
      // Tab 0 = Presets (is_preset: true), Tab 1 = Nutrient Filters (is_preset: false)
      this.filterIsPreset = newTab === 0;
      // Clear form values when switching tabs
      this.filterName = '';
      this.filterTitle = '';
      this.filterDescription = '';
      this.filterIsHardRule = null;
      this.targets = [];
      this.restriction = [];
      this.publishedFilter = null;
    }
  },
  computed: {
    ...mapState(['nutrients']),
    mealSizes() {
      return MEAL_SIZES;
    },
    restrictionLine() {
      if (!this.restriction.length) return 'none';
      return this.restriction.map(id => (this.restrictions && this.restrictions[id] ? this.restrictions[id].text : id)).join(', ');
    },
    ...mapGetters(['getDietName']),
    headers() {
      return [...this.defaultHeaders, ...this.targetHeaders, ...this.restrictionHeaders]
    },
    filteredMeals() {
      if (this.isCheckStale) {
        return [];
      }
      let meals = this.meals;
      if (this.showCriteria) {
        const hasProblem = m => m.hasProblem && (m.hasProblem.restrictions || m.hasProblem.targets);
        if (this.showCriteria === 'problem') {
          meals = meals.filter(hasProblem)
        }
        if (this.showCriteria === 'valid') {
          meals = meals.filter(m => !hasProblem(m))
        }
      }
      return meals;
    },
    isCheckStale() {
      if (this.checkMode === 'live') return false;
      // console.log('is stale', this.lastTargetSearch);
      // console.log('is stale', this.serialiseCheck());
      return this.lastTargetSearch !== this.serialiseCheck();
    },
    nutrientsFiltered() {
      return Object
        .values(this.nutrients)
        .filter(n => !this.onlyTracked || n.tracked)
    },
    restrictionsArray() {
      return Object.values(this.restrictions)
    },
    filteredAvailableFilters() {
      // currentTab: 0 = Presets, 1 = Nutrient Filters
      const isPresetTab = this.currentTab === 0;
      return this.availableFilters.filter(filter => filter.is_preset === isPresetTab);
    },
    configDifferences() {
      if (!this.publishedFilter || !this.filterName) {
        return [];
      }

      // Only compare the actual filter configuration, not metadata like id and is_published
      const publishedConfig = {
        nutrient_targets: this.publishedFilter.nutrient_targets || [],
        restrictions: this.publishedFilter.restrictions || [],
        description: this.publishedFilter.description,
        title: this.publishedFilter.title,
        is_preset: this.publishedFilter.is_preset,
        is_hard_rule: this.publishedFilter.is_hard_rule
      };

      const currentConfig = {
        nutrient_targets: this.targets.filter(t => Object.values(t).some(v => !!v)),
        restrictions: this.restriction,
        description: this.filterDescription,
        title: this.filterTitle,
        is_preset: this.filterIsPreset,
        is_hard_rule: this.filterIsHardRule
      };

      return diff(publishedConfig, currentConfig);
    },
    hasUnpublishedChanges() {
      return this.configDifferences.length > 0;
    },
    formattedChanges() {
      return this.configDifferences.map(change => {
        const path = change.path.join('.');
        const formatted = {
          type: change.type,
          path: path,
          oldValue: change.oldValue,
          value: change.value
        };

        // Format values for better display
        if (typeof formatted.oldValue === 'object' && formatted.oldValue !== null) {
          formatted.oldValue = JSON.stringify(formatted.oldValue, null, 2);
        }
        if (typeof formatted.value === 'object' && formatted.value !== null) {
          formatted.value = JSON.stringify(formatted.value, null, 2);
        }

        return formatted;
      });
    }
  },
  methods: {
    ...mapActions(['fetchDiets', 'fetchNutrients', 'fetchRestrictions']),
    getNextWeekDates() {
      const today = new Date();
      const nextWeek = new Date(today);
      nextWeek.setDate(today.getDate() + 7);

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      return [formatDate(today), formatDate(nextWeek)];
    },
    fetchData(from = 0) {
      if (this.loading) {
        return false;
      }

      if (from === 0) {
        this.meals = [];
        this.mealMap = {};
        this.loading = true;
      }
      const [fromDate, toDate] = this.dates || [];
      if (!(fromDate && toDate)) {
        console.log('no date range selected');
        this.loading = false;
        return;
      }

      function f(d) {
        return `${d}T00:00:00.000Z`
      }

      const where = {
        date: {
          gte: f(fromDate),
          lte: f(toDate),
        }
      };
      // console.log('fetching', {from});
      return api
        .get(`/v2/meal`, {
          params: {
            from,
            // limit,
            // sortBy,
            // sortDesc,
            orderBy: {date: 'asc'},
            where,
            minimal: true
          }
        })
        .then(({data}) => {
          const {count, meals} = data;
          console.log('got data', {count, meals});
          // console.log('first', JSON.stringify(meals[0]));
          // console.log('last', JSON.stringify(meals[meals.length - 1]));

          meals.forEach(meal => {
            const existing = this.mealMap[meal.id];
            if (existing) {
              console.log('dupe', {existing, meal})
            } else {
              this.mealMap[meal.id] = meal;
              if (Object.keys(meal.images || {}).length === 0) {
                delete meal.images;
                meal.noImages = true;
              }
              meal.diet = this.getDietName(meal.diet);
              meal.targets = {};
              meal.sizes = null;
              meal.restriction = {};
              meal.hasProblem = {};
              this.meals.push(meal);
            }
          })
          if (meals.length > 0 && this.meals.length < count) {
            return this.fetchData(from + meals.length);
          }
        })
        .then(() => {
          // the outermost call resolves once every page of meals is in
          if (from === 0) this.loadFilterData();
        })
        .finally(() => {
          this.loading = false;

        })
    },
    dateFormatted,
    /** 'Saturated fat: min 10 g · max 23 g', the one line a target folds to */
    targetLine(target) {
      const nutrient = this.nutrients && this.nutrients[target.nutrient_id];
      const name = nutrient ? nutrient.nutrientname : target.nutrient_id;
      const unit = this.getUnit(target) || '';
      const parts = [['min', target.lower_limit], ['max', target.upper_limit], ['target', target.target]]
        .filter(([, value]) => value !== '' && value !== null && value !== undefined)
        .map(([label, value]) => `${label} ${value} ${unit}`.trim());
      return `${name}: ${parts.length ? parts.join(' · ') : 'no limits yet'}`;
    },
    addTarget() {
      this.targets.push(this.createTargetData());
      this.editingTargetIndex = this.targets.length - 1;
    },
    removeTarget(i) {
      this.targets.splice(i, 1);
      if (this.editingTargetIndex === i) this.editingTargetIndex = null;
      else if (this.editingTargetIndex > i) this.editingTargetIndex -= 1;
    },
    getUnit(target) {
      const nutrient = target && this.nutrients && this.nutrients[target.nutrient_id];
      return target && nutrient && nutrient.unit;
    },
    createTargetData() {
      return {
        nutrient_id: '',
        upper_limit: '',
        lower_limit: '',
        target: ''
      }
    },
    serialiseCheck() {
      return JSON.stringify({targets: this.targets, restriction: this.restriction});
    },
    check() {
      this.checking = true;
      const promises = [];
      if (this.targets.length) {
        promises.push(this.checkTargets())
      }
      if (this.restriction) {
        promises.push(this.checkRestrictions())
      }
      this.setResultHeaders();

      this.lastTargetSearch = this.serialiseCheck();
      // console.log('check setting',this.lastTargetSearch)
      return Promise.all(promises).finally(() => this.checking = false);
    },
    async checkRestrictions() {
      for (const meal of this.meals) {
        await api
          .post(`v2/restrictions`, {mealIds: [meal.id], restrictionIds: this.restriction})
          .then(r => {
            // console.log('result', r.data);
            this.$set(meal.hasProblem, 'restrictions', Object.keys(r.data).length > 0);
            Object.keys(r.data)
              .forEach(foodId => {
                Object.keys(r.data[foodId])
                  .forEach(restrictionId => {
                    const restrictions = meal.restriction[restrictionId] || [];
                    restrictions.push(foodId);
                    this.$set(meal.restriction, restrictionId, restrictions);
                  })
              })
            // r.data.forEach(result => {
            //   this.$set(meal.targets, result.target.nutrient_id, result);
            //   if (result.problem) {
            //     meal.hasProblem = true;
            //   }
            // })
            // console.log('meal after', meal)
          });
      }
    },
    async checkTargets() {

      function scaleTargets(targets) {
        return targets.map(t => {
          const result = {nutrient_id: t.nutrient_id};
          for (const k of ['upper_limit', 'lower_limit', 'target']) {
            if (t[k]) {
              result[k] = t[k] * 3
            }
          }
          return result;
        })
      }

      const targets = this.isDailyTarget ? this.targets : scaleTargets(this.targets);
      for (const meal of this.meals) {
        await api
          .post(`meals/nutrients`, {mealIds: [meal.id], targets})
          .then(r => {
            // console.log('result', r.data);
            this.$set(meal.hasProblem, 'targets', false);
            r.data.forEach(result => {
              this.$set(meal.targets, result.target.nutrient_id, result);
              if (result.problem) {
                this.$set(meal.hasProblem, 'targets', true);
              }
            })
            // the server checks the medium size only
            this.$set(meal, 'sizes', {small: null, medium: !meal.hasProblem.targets, large: null});
            // console.log('meal after', meal)
          });
      }
    },
    /** each meal's nutrients by size and foods with tags, a batch a request; the live check runs as batches land */
    async loadFilterData() {
      const missing = this.meals.filter(meal => !this.filterData[meal.id]);
      if (!missing.length) {
        this.applyLiveCheck();
        return;
      }
      this.filterDataPending = true;
      this.filterDataLoaded = this.meals.length - missing.length;
      const batches = [];
      for (let i = 0; i < missing.length; i += FILTER_DATA_BATCH) {
        batches.push(missing.slice(i, i + FILTER_DATA_BATCH));
      }
      let next = 0;
      const worker = async () => {
        while (next < batches.length) {
          const batch = batches[next++];
          try {
            const {data} = await api.post('meals/filter-data', {mealIds: batch.map(meal => meal.id)});
            for (const meal of batch) {
              this.$set(this.filterData, meal.id, data[meal.id] || null);
            }
          } catch (e) {
            console.error('failed to load meal filter data', e);
          }
          this.filterDataLoaded += batch.length;
          this.applyLiveCheck();
        }
      };
      try {
        await Promise.all(Array.from({length: Math.min(FILTER_DATA_CONCURRENCY, batches.length)}, worker));
      } finally {
        this.filterDataPending = false;
      }
    },
    /** every meal against the targets and restrictions, here in the browser; the results the table shows */
    applyLiveCheck() {
      if (this.checkMode !== 'live') return;
      this.setResultHeaders();
      const targets = mealTargets(this.targets, this.nutrients || {}, this.isDailyTarget);
      const restrictedTags = restrictedTagsOf(this.restriction, this.restrictions || {});
      for (const meal of this.meals) {
        const checked = checkMealData(this.filterData[meal.id], targets, restrictedTags);
        this.$set(meal, 'targets', checked.targets);
        this.$set(meal, 'sizes', checked.sizes);
        this.$set(meal, 'restriction', checked.restriction);
        this.$set(meal, 'hasProblem', checked.hasProblem);
      }
      this.lastTargetSearch = this.serialiseCheck();
    },
    setResultHeaders() {
      this.restrictionHeaders = this.restriction.map(id => ({
        value: `restriction.${id}`, text: this.restrictions[id] ? this.restrictions[id].text : `${id} (text not found)`
      }))
      this.targetHeaders = this.targets.map(t => ({
        value: `targets.${t.nutrient_id}`,
        text: this.nutrients[t.nutrient_id] ? this.nutrients[t.nutrient_id].nutrientname : t.nutrient_id
      }))
    },
    async fetchFilters() {
      await api.get('/v2/meal-filter')
        .then(({data}) => this.availableFilters = data);
      console.log('fetched filters', this.availableFilters);
      this.availableFilters.sort((a, b) => (a.id || '').localeCompare(b.id || ''));
    },
    async saveFilter() {
      const {filterName, targets, restriction, filterDescription, filterTitle} = this;
      const nutrients = Object.values(this.nutrients);

      this.saving = true;
      try {
        await api.put(`v2/meal-filter/${filterName}`, {
          title: filterTitle,
          nutrient_targets: targets
            .filter(t => Object.values(t).some(v => !!v))
            .map(t => {
              // console.log('looking up sym', t)
              const nutrient = nutrients.find(n => n.nutrientnameid === t.nutrient_id);
              const nutrientSymbol = nutrient && nutrient.nutrientsymbol;
              return ({
                ...t,
                nutrient_symbol: nutrientSymbol
              });
            })
          ,
          restrictions: restriction,
          description: filterDescription,
          is_preset: this.filterIsPreset || false,
          is_hard_rule: this.filterIsHardRule || false,
        });
        await this.fetchFilters();
        await this.fetchPublishedFilter(filterName);
      } finally {
        this.saving = false;
      }
    },
    async fetchPublishedFilter(filterName) {
      if (!filterName) return;

      try {
        const {data} = await api.get(`v2/meal-filter/${filterName}/published`);
        this.publishedFilter = data;
      } catch (e) {
        console.error('failed to fetch published filter', e);
        this.publishedFilter = null;
      }
    },
    async publishFilter() {
      if (!this.filterName) return;

      this.publishing = true;
      try {
        // If it's a new filter (not saved yet), save it first
        if (!this.isLoadedFilter) {
          await this.saveFilter();
          this.isLoadedFilter = true;
        }

        await api.post(`v2/meal-filter/${this.filterName}/publish`);
        await this.fetchFilters();
        await this.fetchPublishedFilter(this.filterName);
        this.filterIsPublished = true;
        alert('Filter published successfully!');
      } catch (e) {
        console.error('failed to publish filter', e);
        alert('Failed to publish filter. Please try again.');
      } finally {
        this.publishing = false;
      }
    },
    async unpublishFilter() {
      if (!this.filterName) return;

      this.unpublishing = true;
      try {
        await api.post(`v2/meal-filter/${this.filterName}/unpublish`);
        await this.fetchFilters();
        await this.fetchPublishedFilter(this.filterName);
        this.filterIsPublished = false;
        this.publishedFilter = null;
        alert('Filter unpublished successfully!');
      } catch (e) {
        console.error('failed to unpublish filter', e);
        alert('Failed to unpublish filter. Please try again.');
      } finally {
        this.unpublishing = false;
      }
    },
    async applyFilter(filterName) {
      const filter = this.availableFilters.find(({id}) => id === filterName);
      if (filter) {
        this.restriction = deepCopy(filter.restrictions) || [];
        this.targets = deepCopy(filter.nutrient_targets) || [];
        this.filterDescription = filter.description;
        this.filterTitle = filter.title;
        this.filterIsPreset = filter.is_preset;
        this.filterIsPublished = filter.is_published;
        this.filterIsHardRule = filter.is_hard_rule;
        this.isLoadedFilter = true;
        this.editingDefinition = false;
        this.editingRestrictions = this.restriction.length === 0;
        this.editingTargetIndex = null;
        // Switch to the correct tab based on filter type
        this.currentTab = filter.is_preset ? 0 : 1;
        // Fetch published version for comparison
        await this.fetchPublishedFilter(filterName);
      } else {
        console.warn('could not find filter', filterName, this.availableFilters);
      }
    },
    newFilter() {
      this.editingDefinition = true;
      this.editingRestrictions = true;
      this.editingTargetIndex = null;
      this.filterName = '';
      this.restriction = [];
      this.targets = [];
      this.filterTitle = '';
      this.filterDescription = '';
      // a new filter takes the type of the tab it is created on (0 = Presets)
      this.filterIsPreset = this.currentTab === 0;
      this.filterIsHardRule = null;
      this.publishedFilter = null;
      this.isLoadedFilter = false;
    },
    skipWeek(direction) {
      // direction: -1 for previous week, 1 for next week
      if (!this.dates || this.dates.length !== 2) return;

      const [fromDate, toDate] = this.dates;
      const from = new Date(fromDate);
      const to = new Date(toDate);

      // Add or subtract 7 days
      from.setDate(from.getDate() + (direction * 7));
      to.setDate(to.getDate() + (direction * 7));

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      this.dates = [formatDate(from), formatDate(to)];
    },
    async checkFilterUsage() {
      if (!this.filterName) return;

      this.checkingUsage = true;
      try {
        const {data} = await api.get(`v2/meal-filter/${this.filterName}/users`);
        this.filterUsers = data;
        this.showUsageDialog = true;
      } catch (e) {
        console.error('failed to fetch filter users', e);
        alert('Failed to check filter usage. Please try again.');
      } finally {
        this.checkingUsage = false;
      }
    },
    async checkUsageAndUnpublish() {
      if (!this.filterName) return;

      this.checkingUsage = true;
      try {
        const {data} = await api.get(`v2/meal-filter/${this.filterName}/users`);
        this.filterUsers = data;
        this.showUsageDialog = true;
      } catch (e) {
        console.error('failed to fetch filter users', e);
        // If check fails, still allow unpublish
        if (confirm('Failed to check usage. Unpublish anyway?')) {
          await this.unpublishFilter();
        }
      } finally {
        this.checkingUsage = false;
      }
    },
    toggleFilterType() {
      if (!this.filterName) return;

      // Toggle the is_preset value
      this.filterIsPreset = !this.filterIsPreset;

      // Switch to the appropriate tab
      this.currentTab = this.filterIsPreset ? 0 : 1;
    },
    checkForExistingFilter() {
      // Check if user typed a filter ID that already exists (only when creating new filter)
      if (!this.filterName || this.isLoadedFilter) {
        return;
      }

      const existingFilter = this.availableFilters.find(f => f.id === this.filterName);
      if (existingFilter) {
        const message = `A filter with ID "${this.filterName}" already exists. Would you like to load it?`;
        if (confirm(message)) {
          this.applyFilter(this.filterName);
        } else {
          // Clear the filter name
          this.filterName = '';
        }
      }
    }
  }
}
</script>
